module.exports = __webpack_public_path__ + "img/signedIn.a09fdc8f.png";